import {Form as AntForm, Space} from 'antd';
import {FormInstance} from 'antd/es/form';
import {ColProps} from 'antd/es/grid/col';
import React, {Dispatch, SetStateAction, FC} from 'react';

import {
    isVisibleAction, IMetaActionInfo, TVisibleMetaActionProp, IUrlConfig,
} from 'entities/metadata';

import {EFormMode} from '../form-types';
import {ActionsItem} from './actions-item';

interface IButtonsProps {
    form?: FormInstance;
    actions?: IMetaActionInfo[];
    onClose?: () => void;
    onBack?: () => void;
    onClearForm?: () => void;
    wrapperCol?: ColProps;
    currentVisibleState?: TVisibleMetaActionProp;
    setFormErrorMessage?: Dispatch<SetStateAction<string | null>>;
    formMode?: EFormMode;
    handleOpenConfirmModal?: () => void;
    urlConfig?: IUrlConfig;
}

export const Buttons: FC<IButtonsProps> = (
    {
        form,
        actions,
        onClose,
        onBack,
        onClearForm,
        wrapperCol,
        setFormErrorMessage,
        currentVisibleState = 'default',
        formMode,
        handleOpenConfirmModal,
        urlConfig,
    }: IButtonsProps,
) => {
    const showButtons = onClose || onBack || actions?.length;
    if (!showButtons) return null;

    const actionsList = actions?.map(
        action => (
            isVisibleAction(currentVisibleState, action.visible || 'default', formMode) && (
                <ActionsItem
                    key={action.actionTitle}
                    action={action}
                    form={form}
                    onClose={onClose}
                    onBack={onBack}
                    onClearForm={onClearForm}
                    setFormErrorMessage={setFormErrorMessage}
                    formMode={formMode}
                    handleOpenConfirmModal={handleOpenConfirmModal}
                    urlConfig={urlConfig}
                />
            )),
    );

    return actionsList?.length ? (
        <AntForm.Item
            className="form-actions buttons"
            wrapperCol={wrapperCol}
        >
            <Space>
                {actionsList}
            </Space>
        </AntForm.Item>
    ) : null;
};
